import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

import { Progress } from 'antd';
import { CheckCircleFilled, CloseCircleFilled, MoreOutlined } from '@ant-design/icons';
import styled from '@xstyled/styled-components';
import { getColor, getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  background: ", ";\n  border-radius: ", ";\n  padding: 20px 24px;\n  transition: box-shadow 0.2s ease;\n  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.12);\n  width: 100%;\n"])), getColor('fillBgWhite'), getSize('typo12'));
var StyledLeftSection = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n"])));
var StyledTitle = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 700;\n  color: ", ";\n  line-height: 1.3;\n"])), getColor('fillIntActive'));
var StyledTotalNumber = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), getColor('contentTitle'));
var StyledCorrectLabel = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 600;\n"])), getColor('contentHeading'));
var StyledProgressRow = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  .ant-progress {\n    flex: 1;\n    margin-bottom: 0;\n  }\n\n  .ant-progress-outer {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-progress-bg {\n    background-color: ", " !important;\n  }\n\n  .ant-progress-inner {\n    background-color: ", " !important;\n  }\n"])), getColor('fillIntActive'), getColor('fillIntSubActive'));
var StyledPercentText = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 700;\n  color: ", ";\n  white-space: nowrap;\n"])), getColor('fillIntActive'));
var StyledScoreText = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  color: ", ";\n"])), getColor('contentBody'));
var StyledRightSection = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 12px;\n"])));
var StyledStatCard = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 88px;\n  height: 100px;\n  border-radius: 12px;\n  background: ", ";\n  padding: 12px 8px;\n"])), function (_ref) {
  var $variant = _ref.$variant,
      theme = _ref.theme;
  return $variant === 'correct' ? getColor('successBgActive')({
    theme: theme
  }) : $variant === 'wrong' ? getColor('errorBgActive')({
    theme: theme
  }) : getColor('fillHighlight1')({
    theme: theme
  });
});
var StyledStatNumber = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-size: 26px;\n  font-weight: 700;\n  color: ", ";\n  line-height: 1;\n"])), function (_ref2) {
  var $variant = _ref2.$variant,
      theme = _ref2.theme;
  return $variant === 'correct' ? getColor('successActive')({
    theme: theme
  }) : $variant === 'wrong' ? getColor('errorActive')({
    theme: theme
  }) : getColor('fillIntActive')({
    theme: theme
  });
});
var StyledStatLabel = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-size: 11px;\n  font-weight: 700;\n  color: ", ";\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n"])), function (_ref3) {
  var $variant = _ref3.$variant,
      theme = _ref3.theme;
  return $variant === 'correct' ? getColor('successActive')({
    theme: theme
  }) : $variant === 'wrong' ? getColor('errorActive')({
    theme: theme
  }) : getColor('fillIntActive')({
    theme: theme
  });
});
var StyledPendingIcon = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .anticon {\n    color: ", ";\n    font-size: 14px;\n    font-weight: bold;\n  }\n"])), getColor('fillIntActive'), getColor('fillBgWhite'));
var StyledCheckCircleIcon = styled(CheckCircleFilled)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-size: 24px;\n  color: ", ";\n"])), getColor('successActive'));
var StyledCloseCircleIcon = styled(CloseCircleFilled)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-size: 24px;\n  color: ", ";\n"])), getColor('errorActive'));
export var SubmissionProgress = function SubmissionProgress(_ref4) {
  var _ref4$total = _ref4.total,
      total = _ref4$total === void 0 ? 3 : _ref4$total,
      _ref4$answered = _ref4.answered,
      answered = _ref4$answered === void 0 ? 1 : _ref4$answered,
      _ref4$currentScore = _ref4.currentScore,
      currentScore = _ref4$currentScore === void 0 ? 1.0 : _ref4$currentScore,
      _ref4$maxScore = _ref4.maxScore,
      maxScore = _ref4$maxScore === void 0 ? 3.0 : _ref4$maxScore,
      correct = _ref4.correct,
      _ref4$wrong = _ref4.wrong,
      wrong = _ref4$wrong === void 0 ? 1 : _ref4$wrong,
      pending = _ref4.pending;
  var percent = +(+correct / +total).toFixed(2);
  return /*#__PURE__*/_jsxs(StyledWrapper, {
    children: [/*#__PURE__*/_jsxs(StyledLeftSection, {
      children: [/*#__PURE__*/_jsxs(StyledTitle, {
        children: [correct, "/", /*#__PURE__*/_jsx(StyledTotalNumber, {
          children: total
        }), ' ', /*#__PURE__*/_jsx(StyledCorrectLabel, {
          children: "c\xE2u \u0111\xFAng"
        })]
      }), /*#__PURE__*/_jsxs(StyledProgressRow, {
        children: [/*#__PURE__*/_jsx(Progress, {
          percent: percent * 100,
          showInfo: false,
          strokeWidth: 14,
          style: {
            flex: 1
          }
        }), /*#__PURE__*/_jsxs(StyledPercentText, {
          children: [percent.toFixed(2), "%"]
        })]
      }), /*#__PURE__*/_jsxs(StyledScoreText, {
        children: ["\u0110i\u1EC3m s\u1ED1 hi\u1EC7n t\u1EA1i:", ' ', /*#__PURE__*/_jsxs("strong", {
          children: [currentScore.toFixed(1), " / ", maxScore.toFixed(1), " \u0111i\u1EC3m"]
        })]
      })]
    }), /*#__PURE__*/_jsxs(StyledRightSection, {
      children: [/*#__PURE__*/_jsxs(StyledStatCard, {
        $variant: "correct",
        children: [/*#__PURE__*/_jsx(StyledCheckCircleIcon, {}), /*#__PURE__*/_jsx(StyledStatNumber, {
          $variant: "correct",
          children: correct
        }), /*#__PURE__*/_jsx(StyledStatLabel, {
          $variant: "correct",
          children: "\u0110\xFAng"
        })]
      }), /*#__PURE__*/_jsxs(StyledStatCard, {
        $variant: "wrong",
        children: [/*#__PURE__*/_jsx(StyledCloseCircleIcon, {}), /*#__PURE__*/_jsx(StyledStatNumber, {
          $variant: "wrong",
          children: wrong
        }), /*#__PURE__*/_jsx(StyledStatLabel, {
          $variant: "wrong",
          children: "Sai"
        })]
      }), pending >= 0 && /*#__PURE__*/_jsxs(StyledStatCard, {
        $variant: "pending",
        children: [/*#__PURE__*/_jsx(StyledPendingIcon, {
          children: /*#__PURE__*/_jsx(MoreOutlined, {})
        }), /*#__PURE__*/_jsx(StyledStatNumber, {
          $variant: "pending",
          children: pending
        }), /*#__PURE__*/_jsx(StyledStatLabel, {
          $variant: "pending",
          children: "Ch\u1EDD ch\u1EA5m"
        })]
      })]
    })]
  });
};